import { Schema as S } from "effect";

/**
 * Insurance type enumeration
 */
export const InsuranceTypeSchema = S.Union(
  [S.Literal("GKV"),
  S.Literal("PKV"),
  S.Literal("SELFPAY"),
  S.Literal("UNKNOWN")]
);

export type InsuranceType = S.Schema.Type<typeof InsuranceTypeSchema>;

/**
 * Disambiguation hint - what additional data is needed
 */
export const DisambiguationHintSchema = S.Union(
  [S.Literal("firstname"),
  S.Literal("additional")]
);

export type DisambiguationHint = S.Schema.Type<typeof DisambiguationHintSchema>;

/**
 * Patient Search Found Response
 * Exactly one patient matched
 */
export const PatientSearchFoundSchema = S.Struct({
  status: S.Literal("FOUND"),
  patientId: S.String,
  insurance: InsuranceTypeSchema,
});

/**
 * Patient Search Ambiguous Response
 * Multiple patients matched, need more data
 */
export const PatientSearchAmbiguousSchema = S.Struct({
  status: S.Literal("AMBIGUOUS"),
  hint: DisambiguationHintSchema,
});

/**
 * Patient Search Not Found Response
 * No patients matched
 */
export const PatientSearchNotFoundSchema = S.Struct({
  status: S.Literal("NOT_FOUND"),
});

/**
 * Patient Search Response Schema
 *
 * Privacy-safe response that never exposes other patients' data.
 * Returns one of three statuses:
 * - FOUND: Exactly one match, includes patient ID and insurance type
 * - AMBIGUOUS: Multiple matches, hints at what additional data is needed
 * - NOT_FOUND: No matches found
 */
export const PatientSearchResponseSchema = S.Union(
  [PatientSearchFoundSchema,
  PatientSearchAmbiguousSchema,
  PatientSearchNotFoundSchema]
);

export type PatientSearchResponse = S.Schema.Type<
  typeof PatientSearchResponseSchema
>;
